.coupon-controls {

  .center {
    display: flex;
    justify-content: center;
    
    a {
      text-decoration: none;
    }
  }

  button{
    padding: 6px 24px;
    font-size: 0.875rem;
    min-height: 44px;
    height: auto;
  }

  .error-wrapper {
    div {
      margin-top: 1rem;
    }
  }
}